import './Divider.css'

function Divider() {
    return(
        <div className="divider"/>
    )
}

export default Divider;